import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {SystemGlobalsService, Role} from './../system-globals.service';
import {SideNavItem} from '../side-nav-item/side-nav-item';
import {plainToClass} from 'class-transformer';
import { INetworkSettings } from '../settings/settings-types';
import { SettingsService } from '../settings/settings.service';

@Component({
  selector: 'side-nav',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss']
})

export class SideNavComponent implements OnInit {

  sideNavItems: SideNavItem[] = [];
  isNavMobileOpen: boolean = false;
  constructor(public globals: SystemGlobalsService,private settingsService: SettingsService,) {
  }


  @ViewChild('sidenavIcon', {static: false}) sidenavIcon;

  ngOnInit() {
    this.sideNavItems = plainToClass(SideNavItem, this.globals.constants.sideNavData);
    if (!this.globals.isFeatureEnabled('crm')) this.sideNavItems = this.filterCrmNavItems(this.sideNavItems);
    if (this.globals.constants.memoBypass) this.sideNavItems = this.sideNavItems.filter(item => item.title == 'Safety Reports');
    this.getSettings();
  }

  toggleMobileNav() {
    this.isNavMobileOpen = !this.isNavMobileOpen
  }

   getSettings() {
      let userRole = this.globals.constants._g_userRole;
      if (userRole === 5) {
        this.settingsService.validSettings().subscribe(result => this.setTokensNavAlert(!result.valid));
      }
    }

    private setTokensNavAlert(show: boolean) {
      const anchor = document.querySelector('a[href="/main/tokens/overview"], a[href="/tokens/overview"]') as HTMLElement;
      if (!anchor) return;

      let badge = anchor.querySelector('.registrar-settings-alert') as HTMLElement;
      const labelSpan = anchor.querySelector('span.nav-label, span.d-sm-none.d-md-block') as HTMLElement;
      if (show) {
        if (!badge) {
          badge = document.createElement('i');
          badge.className = 'registrar-settings-alert fas fa-exclamation-triangle';
          badge.style.color = '#dc3545';
          if (labelSpan && labelSpan.parentElement === anchor) {
            anchor.insertBefore(badge, labelSpan);
          } else {
            anchor.appendChild(badge);
          }
        }
      } else if (badge) {
        badge.remove();
      }
    }

    private filterCrmNavItems(items: SideNavItem[]): SideNavItem[] {
      return items
        .filter((item) => !this.isCrmNavItem(item))
        .map((item) => {
          item.children = this.filterCrmNavItems(item.children || []);
          return item;
        });
    }

    private isCrmNavItem(item: SideNavItem): boolean {
      const rawItem = item as any;
      const title = (rawItem.title || rawItem.name || '').toString().trim().toLowerCase();
      const route = (rawItem.route || '').toString().trim().toLowerCase();

      return title === 'crm'
        || route === '/crm'
        || route === '/main/crm'
        || route.indexOf('/crm/') !== -1
        || route.indexOf('/main/crm/') !== -1;
    }

}
